import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { switchMap, tap } from 'rxjs';

import { SharedSettings } from '../models/shared-settings';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class HubService {

    constructor(private settings: SharedSettings, private auth: AuthService, private msal: MsalService) {

    }

    connect(hubName: string): HubConnection {
        const connection = new HubConnectionBuilder()
            .withUrl(this.settings.hubsBaseUrl + hubName, {
                accessTokenFactory: () => new Promise<string>((resolve, reject) => {
                    this.auth.getAccount()
                        //.pipe(tap(acct => console.log(acct)))
                        .pipe(switchMap(account => this.msal.acquireTokenSilent({
                            account: account,
                            scopes: this.settings.authScopes
                        })))
                        .subscribe({
                            next: authResult => resolve(authResult.accessToken),
                            error: err => reject(err)
                        });
                })
            })
            .withAutomaticReconnect()
            .build();

        return connection;
    }
}
